import { transform, transformMark } from "./venn";

export * from "./interface";

export * from "./utils/interface";

export * from "./utils/path";

export const vennTransform = transform;

export const vennMarkTransform = transformMark;
//# sourceMappingURL=index.js.map